export default __webpack_public_path__ + "static/media/letter-a.f72fbbde.svg";